import { render } from "./TargetPage.vue?vue&type=template&id=10ee143c&scoped=true"
import script from "./TargetPage.vue?vue&type=script&lang=js"
export * from "./TargetPage.vue?vue&type=script&lang=js"

import "./TargetPage.vue?vue&type=style&index=0&id=10ee143c&scoped=true&lang=css"

import exportComponent from "C:\\pythonproject0\\tkrforntend\\tkrforntend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10ee143c"]])

export default __exports__